import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Modal from 'shared/Modal';
import SignInForm from './SignInForm';
import SignUpForm from './SignUpForm';
import ForgotPasswordForm from './ForgotPasswordForm';

import { withUser } from '../contexts/user';

class UserSignInLink extends Component {
  constructor(props) {
    super(props);

    this.state = {
      signInOpen: false,
      signUpOpen: false,
      forgotPasswordOpen: false
    };
  }

  handleSignInClick = (event) => {
    event.preventDefault();

    if (this.props.user.currentUser) return;

    this.setState({ signInOpen: true });
  }

  displaySignUpForm = () => {
    this.setState({ signInOpen: false, signUpOpen: true, forgotPasswordOpen: false });
  }

  displaySignInForm = () => {
    this.setState({ signInOpen: true, signUpOpen: false, forgotPasswordOpen: false });
  }

  displayForgotPasswordForm = () => {
    this.setState({ signInOpen: false, signUpOpen: false, forgotPasswordOpen: true });
  }

  handleSignIn = (user) => {
    this.setState({ signInOpen: false });
    this.props.user.logIn(user);
  }

  handleSignUp = (user) => {
    this.setState({ signUpOpen: false });
    this.props.user.logIn(user);
  }

  handleForgotPasswordRequest = () => {
    this.setState({ forgotPasswordOpen: false });
  }

  handleModalClose = () => {
    this.setState({ signInOpen: false, signUpOpen: false, forgotPasswordOpen: false });
  }

  render() {
    const { signInOpen, signUpOpen, forgotPasswordOpen } = this.state;
    const isModalOpen = signInOpen || signUpOpen || forgotPasswordOpen;
    const modalHeader = signInOpen ? 'Sign in' : signUpOpen ? 'Sign up' : 'Reset password';

    return (
      <React.Fragment>
        <a className="user-sign-in-link" onClick={this.handleSignInClick}>Sign in</a>

        {isModalOpen && (
          <Modal
            className={`${signInOpen ? 'sign-in-modal' : signUpOpen ? 'sign-up-modal' : ''}`}
            headerText={modalHeader}
            onModalClose={this.handleModalClose.bind(this)}
          >
            {signInOpen && (
              <SignInForm onSignIn={this.handleSignIn} onSignUpClick={this.displaySignUpForm} onForgotPasswordClick={this.displayForgotPasswordForm} />
            )}

            {signUpOpen && (
              <SignUpForm onSignUp={this.handleSignUp} onSignInClick={this.displaySignInForm} onModalClosed={this.handleModalClose.bind(this)} />
            )}

            {forgotPasswordOpen && (
              <ForgotPasswordForm onRequestSent={this.handleForgotPasswordRequest} />
            )}
          </Modal>
        )}
      </React.Fragment>
    );
  }
}

UserSignInLink.defaultProps = {};

UserSignInLink.propTypes = {
  user: PropTypes.object.isRequired
};

export default withUser(UserSignInLink);
